import React from "react";
import { BaseDrawer } from "./base";

interface LocationDrawerProps {
  location: any;
  onClose: () => void;
}

export function LocationDrawer({ location, onClose }: LocationDrawerProps) {
  return <BaseDrawer entity={location} entityType="location" onClose={onClose} />;
}
